import React from "react";
import Class5Message from "./Class5Message.js";

export default function ResultDisplayClass5(props) {
    const resFive = props.res.filter(r => r.display_class === 5);
    return (
        <Class5Message res={resFive} address={props.address} />
    )
}